/* Håndfull — priskalkulator
   Regner ut månedspris og mengde ut fra antall personer, og legger
   abonnementet i handlekurven. Alle tall kommer fra seksjonsinnstillingene. */
(function () {
  'use strict';

  var nf = new Intl.NumberFormat('nb-NO');

  /* Liquid gir variant.weight i GRAM, mens variant.weight_unit er butikkens
     visningsenhet. De to hører ikke sammen — en 1 kg-pose kommer som 1000 med
     enheten "kg". Vekten leses derfor alltid som gram.
     Faller tilbake på variantnavnet ("500g", "1kg") hvis vekt mangler. */
  function gramForVariant(v) {
    var g = Number(v.vekt) || 0;
    if (g > 0) return g;
    var m = String(v.tittel).match(/([\d.,]+)\s*(kg|g)\b/i);
    if (!m) return 0;
    var tall = parseFloat(m[1].replace(',', '.'));
    return m[2].toLowerCase() === 'kg' ? tall * 1000 : tall;
  }

  /* Et produkt kan ha flere abonnementsplaner (hver uke, hver måned …).
     Velger vi feil, blir kunden trukket oftere enn prisen viser. Derfor
     matcher vi på navnet fra innstillingene før vi eventuelt tar den første. */
  function velgSalgsplan(produkt, sokeord) {
    var planer = produkt.salgsplaner || [];
    if (!planer.length) return null;
    var ord = String(sokeord || '').trim().toLowerCase();
    if (ord) {
      for (var i = 0; i < planer.length; i++) {
        var navn = (planer[i].navn || '') + ' ' + (planer[i].gruppe || '');
        if (navn.toLowerCase().indexOf(ord) !== -1) return planer[i];
      }
      return null;
    }
    return planer[0];
  }

  function lesRabattrapp(tekst) {
    return String(tekst || '')
      .split(',')
      .map(function (d) {
        var p = d.split(':');
        return { fra: parseInt(p[0], 10), rabatt: parseFloat(p[1]) };
      })
      .filter(function (t) { return !isNaN(t.fra) && !isNaN(t.rabatt); })
      .sort(function (a, b) { return a.fra - b.fra; });
  }

  function rabattFor(trapp, antall) {
    var r = 0;
    for (var i = 0; i < trapp.length; i++) {
      if (antall >= trapp[i].fra) r = trapp[i].rabatt;
    }
    return r;
  }

  /* Skissen skriver «12,5kg» uten mellomrom. */
  function formaterKilo(gram) {
    var kg = gram / 1000;
    var tall = kg >= 10 ? Math.round(kg * 10) / 10 : Math.round(kg * 100) / 100;
    return nf.format(tall) + 'kg';
  }

  /* Skissen skriver «1295 kr» og «2595 kr», uten tusenskille. */
  function formaterKroner(kr) {
    return String(Math.round(kr)) + ' kr';
  }

  function Kalkulator(rot) {
    this.rot = rot;
    this.min = parseInt(rot.dataset.min, 10) || 1;
    this.maks = parseInt(rot.dataset.max, 10) || 250;
    this.prisPerPerson = parseFloat(String(rot.dataset.prisPerPerson).replace(',', '.')) || 0;
    this.gramPerPerson = parseFloat(rot.dataset.gramPerPerson) || 500;
    this.trapp = lesRabattrapp(rot.dataset.rabattrapp);
    this.avrunding = parseInt(rot.dataset.avrunding, 10) || 1;
    this.knappLenke = rot.dataset.knappLenke || '';
    this.salgsplanNavn = rot.dataset.salgsplanNavn || '';
    this.krevSalgsplan = rot.dataset.krevSalgsplan === 'true';
    this.visFordeling = rot.dataset.visFordeling !== 'false';

    /* «produkt» henter prisen fra sortene kunden har krysset av, slik at
       valnøtter koster mindre enn cashew — og slik at tallet i kortet er det
       samme som summen i handlekurven. «fast» er den gamle flate prisen per
       person, uavhengig av sort. */
    this.prismodell = rot.dataset.prismodell || 'produkt';

    this.felt = rot.querySelector('[data-hfk-tall]');
    this.glider = rot.querySelector('[data-hfk-glider]');
    this.prisEl = rot.querySelector('[data-hfk-pris]');
    this.perPersonEl = rot.querySelector('[data-hfk-perperson]');
    this.knapp = rot.querySelector('[data-hfk-bestill]');
    this.feilEl = rot.querySelector('[data-hfk-feil]');
    this.fordelingEl = rot.querySelector('[data-hfk-fordeling]');
    this.avkryss = Array.prototype.slice.call(rot.querySelectorAll('[data-hfk-produkt]'));
    this.mengdeEl = Array.prototype.slice.call(rot.querySelectorAll('[data-hfk-mengde]'));

    var raa = rot.querySelector('[data-hfk-produkter]');
    try { this.produkter = JSON.parse(raa ? raa.textContent : '[]'); }
    catch (e) { this.produkter = []; }

    this.koble();
    this.oppdater();
  }

  Kalkulator.prototype.antall = function () {
    var n = parseInt(this.felt ? this.felt.value : this.glider.value, 10);
    if (isNaN(n)) n = this.min;
    return Math.min(this.maks, Math.max(this.min, n));
  };

  Kalkulator.prototype.koble = function () {
    var self = this;
    function synk(kilde) {
      return function () {
        var n = self.antall();
        if (kilde === 'felt' && self.glider) self.glider.value = n;
        if (kilde === 'glider' && self.felt) self.felt.value = self.glider.value;
        self.oppdater();
      };
    }
    if (this.glider) this.glider.addEventListener('input', synk('glider'));
    if (this.felt) {
      this.felt.addEventListener('input', function () {
        if (self.glider) self.glider.value = self.felt.value;
        self.oppdater();
      });
      this.felt.addEventListener('blur', function () { self.felt.value = self.antall(); synk('felt')(); });
    }
    this.avkryss.forEach(function (a) {
      a.addEventListener('change', function () {
        if (!self.avkryss.some(function (x) { return x.checked; })) a.checked = true;
        self.oppdater();
      });
    });
    if (this.knapp) this.knapp.addEventListener('click', function () { self.bestill(); });
  };

  /* Prisen i øre for én pose. Kalkulatoren står bare på bedriftssidene, og
     der er prisene uten mva. Nettoprisen fra prislista ligger på varianten som
     metafeltet pris_eks_mva; finnes den ikke, brukes bruttoprisen. */
  Kalkulator.prototype.variantPris = function (v) {
    if (Number(v.pris_eks) > 0) return Number(v.pris_eks);
    return Number(v.pris) || 0;
  };

  /* Abonnementsplanen kan gi rabatt. Uten dette viser kortet full pris mens
     handlekurven trekker fra rabatten, og tallene stemmer ikke overens. */
  function planPris(ore, plan) {
    var just = plan && plan.justering ? plan.justering : [];
    for (var i = 0; i < just.length; i++) {
      var t = String(just[i].type || '').toLowerCase();
      var v = Number(just[i].verdi) || 0;
      if (t.indexOf('percentage') !== -1) ore = ore * (1 - v / 100);
      else if (t.indexOf('fixed') !== -1) ore = Math.max(0, ore - v);
      else if (t === 'price') ore = v;
    }
    return ore;
  }

  /* Deler mengden på hele poser: størst først, og den minste posen fyller
     resten. 12,5 kg blir 12 × 1 kg + 1 × 500 g — ikke 13 kg. Glassrør holdes
     utenfor; det er en gaveform, ikke en abonnementspose. */
  Kalkulator.prototype.poser = function (produkt, gram) {
    var varianter = (produkt.varianter || []).filter(function (v) {
      return gramForVariant(v) > 0 && !/glassr/i.test(String(v.tittel));
    });
    var tilgjengelige = varianter.filter(function (v) { return v.tilgjengelig; });
    if (tilgjengelige.length) varianter = tilgjengelige;
    if (!varianter.length) return [];

    varianter.sort(function (a, b) { return gramForVariant(b) - gramForVariant(a); });

    var rest = gram;
    var ut = [];
    for (var i = 0; i < varianter.length; i++) {
      var g = gramForVariant(varianter[i]);
      var antall = Math.floor(rest / g);
      if (i === varianter.length - 1 && rest > 0) antall = Math.max(antall, Math.ceil(rest / g));
      if (antall > 0) { ut.push({ variant: varianter[i], antall: antall }); rest -= antall * g; }
    }
    if (!ut.length) ut.push({ variant: varianter[varianter.length - 1], antall: 1 });
    return ut;
  };

  /* Alt kunden faktisk får: poser per valgt sort, med pris. */
  Kalkulator.prototype.pakke = function (gramTotalt) {
    var self = this;
    var produkter = this.valgteProdukter();
    if (!produkter.length) return { deler: [], ore: 0, gram: 0 };
    var gramHver = gramTotalt / produkter.length;
    var ore = 0;
    var gram = 0;
    var deler = produkter.map(function (p) {
      var poser = self.poser(p, gramHver);
      var plan = velgSalgsplan(p, self.salgsplanNavn);
      poser.forEach(function (l) {
        ore += planPris(self.variantPris(l.variant), plan) * l.antall;
        gram += gramForVariant(l.variant) * l.antall;
      });
      return { produkt: p, poser: poser, plan: plan };
    });
    return { deler: deler, ore: ore, gram: gram };
  };

  Kalkulator.prototype.beregn = function () {
    var n = this.antall();
    var gram = n * this.gramPerPerson;
    var rabatt = rabattFor(this.trapp, n);

    if (this.prismodell === 'produkt') {
      var pakke = this.pakke(gram);
      if (pakke.ore > 0) {
        var kroner = (pakke.ore / 100) * (1 - rabatt / 100);
        return { antall: n, pris: Math.round(kroner), rabatt: rabatt, gram: pakke.gram || gram };
      }
    }

    var brutto = n * this.prisPerPerson;
    var netto = brutto * (1 - rabatt / 100);
    var pris = Math.round(netto / this.avrunding) * this.avrunding;
    return { antall: n, pris: pris, rabatt: rabatt, gram: gram };
  };

  Kalkulator.prototype.oppdater = function () {
    var r = this.beregn();
    if (this.prisEl) this.prisEl.textContent = formaterKroner(r.pris);
    if (this.perPersonEl) {
      var pp = r.antall > 0 ? r.pris / r.antall : 0;
      var enhet = this.perPersonEl.dataset.enhet || 'person';
      this.perPersonEl.textContent = '(' + formaterKroner(pp) + ' per ' + enhet + ' per måned)';
    }

    var valgteProd = this.valgteProdukter();
    var antallValgte = valgteProd.length || 1;
    var sorter = valgteProd.map(function (p) { return p.tittel; });
    var sortTekst = sorter.length > 1
      ? sorter.slice(0, -1).join(', ') + ' og ' + sorter[sorter.length - 1]
      : (sorter[0] || '');

    /* «[mengde] [sort]» gir skissens «12,5kg Rå blanding»: hele mengden og
       navnet på sorten(e) som er krysset av. Uten [sort] vises mengden per sort. */
    this.mengdeEl.forEach(function (el) {
      var mal = el.dataset.mal || '[mengde]';
      var medSort = mal.indexOf('[sort]') !== -1;
      var gram = medSort ? r.gram : r.gram / antallValgte;
      el.textContent = mal.replace('[mengde]', formaterKilo(gram)).replace('[sort]', sortTekst);
    });

    /* Uten denne linjen skjer det ingenting synlig når man krysser av,
       og avkryssingen føles død selv om den styrer hva som havner i kurven. */
    if (this.fordelingEl) {
      if (!this.visFordeling || !valgteProd.length) {
        this.fordelingEl.textContent = '';
      } else {
        var perProdukt = formaterKilo(r.gram / valgteProd.length);
        var navn = valgteProd.map(function (p) { return p.tittel; });
        var tekst;
        if (navn.length === 1) {
          tekst = perProdukt + ' ' + navn[0] + ' per måned';
        } else {
          var sisteTo = navn.slice(0, -1).join(', ') + ' og ' + navn[navn.length - 1];
          tekst = perProdukt + ' av hver: ' + sisteTo;
        }
        this.fordelingEl.textContent = tekst;
      }
    }

    this.rot.dispatchEvent(new CustomEvent('hfk:endret', { detail: r, bubbles: true }));
  };

  Kalkulator.prototype.valgteProdukter = function () {
    var valgte = this.avkryss.filter(function (a) { return a.checked; })
                             .map(function (a) { return String(a.value); });
    return this.produkter.filter(function (p) { return valgte.indexOf(String(p.id)) !== -1; });
  };

  /* Handlekurvlinjene er nøyaktig de posene prisen er regnet ut fra. */
  Kalkulator.prototype.linjer = function () {
    var self = this;
    var r = this.beregn();
    var pakke = this.pakke(r.antall * this.gramPerPerson);
    if (!pakke.deler.length) return { linjer: [], manglerPlan: [] };
    var manglerPlan = [];
    var linjer = [];

    pakke.deler.forEach(function (del) {
      if (!del.plan) manglerPlan.push(del.produkt.tittel);
      del.poser.forEach(function (l) {
        if (!l.variant || !l.variant.id) return;
        var linje = { id: l.variant.id, quantity: l.antall };
        if (del.plan) linje.selling_plan = del.plan.id;
        linjer.push(linje);
      });
    });

    return { linjer: linjer, manglerPlan: manglerPlan };
  };

  Kalkulator.prototype.visFeil = function (melding) {
    if (!this.feilEl) return;
    this.feilEl.textContent = melding || '';
    this.feilEl.hidden = !melding;
  };

  Kalkulator.prototype.bestill = function () {
    var self = this;
    var r = this.beregn();

    if (this.knappLenke) {
      var skille = this.knappLenke.indexOf('?') === -1 ? '?' : '&';
      var navn = this.valgteProdukter().map(function (p) { return p.tittel; }).join(', ');
      window.location.href = this.knappLenke + skille +
        'antall=' + r.antall +
        '&pris=' + r.pris +
        '&produkter=' + encodeURIComponent(navn);
      return;
    }

    var res = this.linjer();
    if (!res.linjer.length) { this.visFeil('Velg minst ett produkt.'); return; }

    /* Uten abonnementsplan ville dette blitt et engangskjøp til månedsprisen.
       Da er det bedre å si fra enn å ta imot bestillingen. */
    if (this.krevSalgsplan && res.manglerPlan.length) {
      this.visFeil('Abonnement er ikke satt opp for ' + res.manglerPlan.join(', ') +
                   ' ennå. Ta kontakt, så ordner vi bestillingen.');
      return;
    }

    this.visFeil('');
    this.knapp.disabled = true;
    var opprinnelig = this.knapp.textContent;
    this.knapp.textContent = 'Legger i handlekurv …';

    var rot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(rot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: res.linjer })
    })
      .then(function (svarRes) { return svarRes.json().then(function (d) { return { ok: svarRes.ok, data: d }; }); })
      .then(function (svar) {
        if (!svar.ok) throw new Error(svar.data.description || svar.data.message || 'Kunne ikke legge i handlekurv.');
        window.location.href = rot + 'cart';
      })
      .catch(function (e) {
        self.visFeil(e.message);
        self.knapp.disabled = false;
        self.knapp.textContent = opprinnelig;
      });
  };

  function start(omrade) {
    (omrade || document).querySelectorAll('[data-hfk]').forEach(function (rot) {
      if (!rot.hfkStartet) { rot.hfkStartet = true; new Kalkulator(rot); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else { start(); }

  /* Nyoppfriskning i temaeditoren */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
